import {
    API_SUCCESS,
    API_FAIL,
    GET_CHARTS_DATA,
    COUNTS_SUCCESS,
    COUNTS_FAIL,
    GET_RECENT_QUOTES_SUCCESS,
    GET_RECENT_QUOTES_FAIL,
    GET_PIE_CHART_SUCCESS,
    GET_BAR_CHART_SUCCESS,
    GET_PIE_CHART_FAIL,
    COUNTS
} from "./actionTypes";

const INIT_STATE = {
    chartsData: []
};

const Dashboard = (state = INIT_STATE, action) => {
    switch (action.type) {
        case API_SUCCESS:
            switch (action.payload.actionType) {
                case GET_CHARTS_DATA:
                    return {
                        ...state,
                        chartsData: action.payload.data
                    };
                default:
                    return state;
            }
        case API_FAIL:
            switch (action.payload.actionType) {
                case GET_CHARTS_DATA:
                    return {
                        ...state,
                        chartsDataError: action.payload.error
                    };


                default:
                    return state;
            }
        default:
            return state;
    }
}

export default Dashboard;

// User counts
const initialState = {
    Counts: [],
    error: {},
    loader: false,
}
export const GetCounts = (state = initialState, action) => {
    switch (action.type) {
        case COUNTS:
            return {
                ...state, 
                loader: true,
            }
        case COUNTS_SUCCESS:
            return {
                ...state,
                Counts: action.payload,
                loader: false,
            }

        case COUNTS_FAIL:
            return {
                ...state,
                error: action.payload,
                loader: false,
            }
        default:
            return state
    }
}

// User RecentQuotes
const initialStateRecentQuotes = {
    recentQuotes: [],
    error: {}
}
export const GetRecentQuotes = (state = initialStateRecentQuotes, action) => {
    switch (action.type) {
        case GET_RECENT_QUOTES_SUCCESS:
            return {
                ...state,
                recentQuotes: action.payload,
            }

        case GET_RECENT_QUOTES_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        default:
            return state
    }
}

// pie chart
const initialStatePieChart = {
    pieChart: [],
    error: {}
}
export const GetPieChart = (state = initialStatePieChart, action) => {
    switch (action.type) {
        case GET_PIE_CHART_SUCCESS:
            return {
                ...state,
                pieChart: action.payload,
            }

        case GET_PIE_CHART_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        default:
            return state
    }
}

// bar chart
const initialStateBarChart = {
    barChart: [],
    error: {}
}
export const GetBarChart = (state = initialStateBarChart, action) => {
    switch (action.type) {
        case GET_BAR_CHART_SUCCESS:
            return {
                ...state,
                barChart: action.payload,
            }

        case GET_RECENT_QUOTES_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        default:
            return state
    }
}